'use strict';
import Assets from '@/services/assets';
import * as types from '../mutation-types';
import Vue from 'vue';

const state = {
  allAssets: [],
  games: [],
  compositions: [],
  loading: false,
  subscribed: {},
};

const getters = {
  allAssets: state => {
    return state.allAssets;
  },
  getLoading: state => state.loading,
  getCompositions: state => {
    return state.compositions;
  },
  getSubscribed: state => {
    return state.subscribed;
  },
};

const actions = {
  async myCreationsAssets({ commit }) {
    commit('resetAssetData');
    commit(types.LOADING, true);
    const response = await Assets.getAll();
    commit('allAssets', response.data);
    commit('gamesAndCompositions');
    commit(types.LOADING, false);
  },
};

const mutations = {
  resetAssetData(state) {
    state.allAssets = [];
    state.games = [];
    state.compositions = [];
    state.loading = false;
  },
  allAssets: (state, assets) => (state.allAssets = assets),
  [types.LOADING](state, boolean) {
    Vue.set(state, 'loading', boolean);
  },
  gamesAndCompositions(state) {
    if (state.allAssets.rows.length > 0) {
      state.allAssets.rows.forEach(asset => {
        if (asset.content_type === 3) {
          state.games.push(asset);
        } else if (asset.content_type === 2) {
          state.compositions.push(asset);
        }
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
